import { collection, doc, addDoc, setDoc, updateDoc, getDocs, query, where, deleteDoc, CollectionReference, DocumentData, runTransaction } from 'firebase/firestore';
import { getTimestamp } from 'common/utils';
import { Category, CategoryActions, Action } from 'common/types';
import { getCategoryEntity } from 'common/assets';
import { db } from 'firebase/config';
import { setDocWithCreatedBy } from 'firebase/utils';
const categoriesCollection: CollectionReference<DocumentData> = collection(db, 'categories');
export const createCategoryActions: Action<CategoryActions> = (state, updateState) => ({
  // add a category
  add: async (category) => {
    const newCategory = getCategoryEntity(category);
    await setDocWithCreatedBy(categoriesCollection, newCategory);
    updateState({ categories: [...state.categories, newCategory] });
    return newCategory;
  },


  // remove the selected category recursively
  remove: async (categoryId) => {
    // Update Firestore
    const categoryRef = doc(categoriesCollection, categoryId);
    await deleteDoc(categoryRef);

    // Delete child categories
    const childrenQuery = query(categoriesCollection, where('parentId', '==', categoryId));
    const childrenSnapshot = await getDocs(childrenQuery);
    const deletePromises = childrenSnapshot.docs.map(doc => deleteDoc(doc.ref));
    await Promise.all(deletePromises);

    // Update local state
    const updCategories = state.categories.filter(category => 
      category.id !== categoryId && category.parentId !== categoryId
    );
    updateState({ categories: updCategories });
  },

  // update a category
  update: async (category) => {
    const updatedCategory = {
      ...category,
      lastModifiedTime: getTimestamp()
    };

    // Update in Firestore
    const categoryRef = doc(categoriesCollection, category.id);
    await updateDoc(categoryRef, updatedCategory);

    // Update local state
    const updCategories = state.categories.map(cat => 
      cat.id === category.id ? updatedCategory : cat
    );
    updateState({ categories: updCategories });
  },

  // set active category
  select: (categoryId) => updateState({ currentCategoryId: categoryId }),

  // intercambiar el sortOrder de dos categorías
  swapSortOrder: async (category1: Category, category2: Category) => {
    const updatedCategory1 = {...category1, sortOrder: category2.sortOrder};
    const updatedCategory2 = {...category2, sortOrder: category1.sortOrder};
    
    // Actualizar el estado local primero para mejorar UX
    updateState({
      categories: state.categories.map(category => 
        category.id === category1.id ? updatedCategory1 : 
        category.id === category2.id ? updatedCategory2 : 
        category
      )
    });
    
    // Actualizar en Firestore mediante una transacción
    await runTransaction(db, async (transaction) => {
      const cat1Ref = doc(categoriesCollection, category1.id);
      const cat2Ref = doc(categoriesCollection, category2.id);
      
      transaction.update(cat1Ref, { sortOrder: category2.sortOrder });
      transaction.update(cat2Ref, { sortOrder: category1.sortOrder });
    });
  },
});

